import PropTypes from 'prop-types';
import { colors } from 'components/styles/variables';

const Categories = ({ categories }) => (
  <ul className="categories">
    {categories.map((category) => (
      <li className="category" key={category.name}>
        {category.name}
      </li>
    ))}
    <style jsx>{`
      .categories {
        padding-left: 0;
        margin-top: 10px;
        font-weight: bold;
        float: left;
      }

      .category {
        list-style: none;
        display: inline-block;
        padding: 2px 5px 0 0;
        color: ${colors.ALR1};
        font-size: 17px;
      }

      .category + .category::before {
        content: ' | ';
        color: ${colors.G2};
        font-weight: normal;
        position: relative;
        display: inline-block;
        margin-right: 5px;
      }
    `}</style>
  </ul>
);
Categories.propTypes = {
  categories: PropTypes.array,
};

export default Categories;
